import * as api from '../api/massMatchSales';
import { createRequestTypes, prefix, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_MASS_LINK_SALE_TO_DEEDS = createRequestTypes(
  `${prefix}/FETCH_MASS_LINK_SALE_TO_DEEDS`,
);

export const fetchMassLinkSaletoDeeds = makeApiActionCreatorV3(
  api.fetchMassLinkSaletoDeeds,
  FETCH_MASS_LINK_SALE_TO_DEEDS[START],
  FETCH_MASS_LINK_SALE_TO_DEEDS[SUCCESS],
  FETCH_MASS_LINK_SALE_TO_DEEDS[ERROR],
);

export const CREATE_MASS_LINK_SALE_TO_DEEDS = createRequestTypes(
  `${prefix}/CREATE_MASS_LINK_SALE_TO_DEEDS`,
);

export const createMassLinkSaletoDeeds = makeApiActionCreatorV3(
  api.createMassLinkSaletoDeeds,
  CREATE_MASS_LINK_SALE_TO_DEEDS[START],
  CREATE_MASS_LINK_SALE_TO_DEEDS[SUCCESS],
  CREATE_MASS_LINK_SALE_TO_DEEDS[ERROR],
);

export const MATCH_MASS_LINK_SALE_TO_DEEDS = createRequestTypes(
  `${prefix}/MATCH_MASS_LINK_SALE_TO_DEEDS`,
);

export const matchMassLinkSaletoDeeds = makeApiActionCreatorV3(
  api.matchMassLinkSaletoDeeds,
  MATCH_MASS_LINK_SALE_TO_DEEDS[START],
  MATCH_MASS_LINK_SALE_TO_DEEDS[SUCCESS],
  MATCH_MASS_LINK_SALE_TO_DEEDS[ERROR],
);

export const FINALIZE_MASS_LINK_SALE_TO_DEEDS = createRequestTypes(
  `${prefix}/FINALIZE_MASS_LINK_SALE_TO_DEEDS`,
);

export const finalizeMassLinkSaletoDeeds = makeApiActionCreatorV3(
  api.finalizeMassLinkSaletoDeeds,
  FINALIZE_MASS_LINK_SALE_TO_DEEDS[START],
  FINALIZE_MASS_LINK_SALE_TO_DEEDS[SUCCESS],
  FINALIZE_MASS_LINK_SALE_TO_DEEDS[ERROR],
);

export const FETCH_MASS_LINK_SALE_TO_DEED_DETAILS = createRequestTypes(
  `${prefix}/FETCH_MASS_LINK_SALE_TO_DEED_DETAILS`,
);

export const fetchMassLinkSaletoDeedDetails = makeApiActionCreatorV3(
  api.fetchMassLinkSaletoDeedDetails,
  FETCH_MASS_LINK_SALE_TO_DEED_DETAILS[START],
  FETCH_MASS_LINK_SALE_TO_DEED_DETAILS[SUCCESS],
  FETCH_MASS_LINK_SALE_TO_DEED_DETAILS[ERROR],
);